import { createContext, useEffect, useState } from "react";
import cookies from "js-cookie";

const LanguageContext = createContext({
  authToken: "",
  languageCodeHandler: () => {},
});

const retrieveStoredLanguageCode = () => "el";

export const LanguageContextProvider = (props) => {
  const lngCode = retrieveStoredLanguageCode();

  let initialLanguageCode;
  if (lngCode) initialLanguageCode = lngCode;

  const [getLanguageCode, setLanguageCode] = useState(initialLanguageCode);

  const languageCodeHandler = (lngCode) => setLanguageCode(lngCode);

  // WCAG 3.1.1 / 3.1.2 — keep <html lang="..."> in sync with the active
  // language so screen readers use the correct pronunciation rules.
  // This fires on mount (sets initial "el") and on every language change.
  useEffect(() => {
    if (getLanguageCode) {
      document.documentElement.setAttribute("lang", getLanguageCode);
    }
  }, [getLanguageCode]);

  const context = {
    languageCode: getLanguageCode,
    languageCodeHandler: languageCodeHandler,
  };

  return (
    <LanguageContext.Provider value={context}>
      {props.children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
